export const CONTACT_EMAIL = 'support@synthohub.com';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const applicationStoreURLs = {
  APPLE_APP_STORE:
    'https://apps.apple.com/us/app/syntho/id1615419392',
  GOOGLE_PLAY_STORE:
    'https://play.google.com/store/apps/details?id=com.syntho',
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const synthoURLs = {
  FAQ: 'https://synthohub.com/faq',
  TERMS_AND_CONDITIONS: 'https://synthohub.com/terms-conditions',
  PRIVACY_POLICY: 'https://synthohub.com/privacy-policy',
};
